import React from 'react'

// @ts-ignore
import WistiaVideo from 'app/domains/common/WistiaVideo'
import { IActivityImageOrActivityVideoProps } from './interface'

const ActivityImageOrActivityVideo: React.FC<IActivityImageOrActivityVideoProps> = ({
  videoId,
  videoThumbnail,
  height = 80,
  imageSrc,
  imageClassName,
  imageAlt,
  demo,
}) => {
  if (videoId) {
    return <WistiaVideo height={height} videoId={videoId} videoThumbnail={videoThumbnail} demo={demo} />
  }
  return <img src={imageSrc} className={imageClassName} alt={imageAlt} />
}

export default ActivityImageOrActivityVideo
